import React, { Component } from "react";
import OtherPosts from "./OtherPosts.js";
import axios from "axios";
import _ from "lodash";
import { Link } from "react-router-dom";
import Hero from "./Hero.js";
import edge from "../assets/edge.svg";
import cs from "../assets/cs-featured.jpg";

import { renderMarkup } from "../utils.js";

class CaseStudies extends Component {
  constructor() {
    super();
    this.state = {
      data: null,
      pageData: []
    };
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/pages?slug=applications").then(res => {
      this.setState(
        {
          pageData: res.data[0].acf
        },
        () => window.scrollTo(0, 0)
      );
    });

    axios
      .get(SITE_URL + "/wp-json/wp/v2/casestudies?per_page=100")
      .then(res => {
        this.setState(
          {
            data: res.data
          },
          () => window.scrollTo(0, 0)
        );
      });
  }

  isOdd = num => {
    return num % 2;
  };

  render() {
    const { data, pageData } = this.state;
    return (
      <div className="case-studies">
        <div className="post-hero bg-gray">
          <img className="edge left" src={edge} alt="Edge Element" />
          <img className="edge right" src={edge} alt="Edge Element" />

          <div className="container">
            <h1>Applications</h1>
          </div>
        </div>
        {_.map(data, (o, i) => {
          return (
            <div
              className={
                this.isOdd(i) ? "cs-hero bg-gray alt" : "cs-hero bg-gray"
              }>
              <div className="flex-container max-width">
                <div className="left box-element">
                  <div>
                    <h4>Application</h4>
                    <h2
                      dangerouslySetInnerHTML={renderMarkup(o.title.rendered)}
                    />
                  </div>
                </div>
                <div className="right">
                  <p dangerouslySetInnerHTML={renderMarkup(o.acf.excerpt)} />
                  <Link className="btn main" to={"/case/" + o.slug}>
                    Get Started
                  </Link>
                  <Link className="btn otl" to={"/case/" + o.slug}>
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default CaseStudies;



// WEBPACK FOOTER //
// ./src/components/CaseStudies.js